var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg18PxUserGroup = function Svg18PxUserGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    className: "18px_user-group_svg__nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 4.25,
    r: 1.5,
    "data-color": "color-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.323 11.499-.852-2.413a1.995 1.995 0 0 0-1.885-1.334H8.412c-.848 0-1.602.535-1.884 1.334l-.851 2.413a.5.5 0 0 0 .334.647l1.239.354.195 3.309a1 1 0 0 0 .998.941h1.114a1 1 0 0 0 .998-.941l.195-3.309 1.239-.354a.5.5 0 0 0 .334-.647",
    "data-color": "color-2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.75,
    cy: 2.75,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.193 15.25h1.114a1 1 0 0 0 .998-.941L15.5 11l1.239-.354a.5.5 0 0 0 .334-.647l-.852-2.413a1.995 1.995 0 0 0-1.885-1.334h-1.174"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.25,
    cy: 2.75,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.807 15.25H3.693a1 1 0 0 1-.998-.941L2.5 11l-1.239-.354a.5.5 0 0 1-.334-.647l.852-2.413a1.995 1.995 0 0 1 1.885-1.334h1.174"
  }))));
};
export default Svg18PxUserGroup;